import React, { useState } from "react";
import { db, storage, } from "../../services/firebaseConfig";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import AlertMessage from "../../components/AlertMessage";

import "../../styles/StockForm.css";

const categories = ["baju", "buku", "runcit"];
const sizes = ["XS", "S", "M", "L", "XL", "2XL", "3XL"];
const years = ["4 tahun", "5 tahun", "6 tahun"];

// 🔥 ID dokumen untuk negeri Selangor (GANTIKAN DENGAN ID YANG BETUL JIKA BERUBAH)

const StockForm = () => {
    const [showAlert, setShowAlert] = useState(false);

    const [category, setCategory] = useState("");
    const [itemName, setItemName] = useState("");
    const [gender, setGender] = useState("");
    const [quantities, setQuantities] = useState({});
    const [image, setImage] = useState(null);
    const [hargaKos, setHargaKos] = useState("");
    const [hargaJualPengerusi, setHargaJualPengerusi] = useState("");
    const [hargaJualPengurus, setHargaJualPengurus] = useState("");
    const [desc, setDesc] = useState("");
    const currentUser = JSON.parse(localStorage.getItem("user"));
    const [hargaSaiz, setHargaSaiz] = useState({});
    const [hargaTahun, setHargaTahun] = useState({});
    const [splitByYear, setSplitByYear] = useState(false);



    const handleImageUpload = async () => {
        if (!image) return null;
        try {
            const imageRef = ref(storage, `stocks/${image.name}`);
            await uploadBytes(imageRef, image);
            return await getDownloadURL(imageRef);
        } catch (error) {
            console.error("Error uploading image:", error);
            return null;
        }
    };

    const addStock = async (e) => {
        e.preventDefault();
        const uploadedImageUrl = await handleImageUpload();
        if (!uploadedImageUrl) {
            alert("Gagal memuat naik gambar.");
            return;
        }

        if (category === "baju") {
            if (!gender) {
                alert("Sila pilih jantina.");
                return;
            }
            // Validation: at least satu saiz mesti ada value > 0
            const jumlah = sizes.reduce((total, size) => total + (parseInt(quantities[size]) || 0), 0);
            if (jumlah === 0) {
                alert("Sekurang-kurangnya satu saiz mesti diisi.");
                return;
            }
        }
        if (category === "buku") {
            if (splitByYear) {
                const jumlah = years.reduce((total, year) => total + (parseInt(quantities[year]) || 0), 0);
                if (jumlah === 0) {
                    alert("Sekurang-kurangnya satu kuantiti tahun buku mesti diisi.");
                    return;
                }
            } else {
                if (!quantities["qty"] || parseInt(quantities["qty"]) <= 0) {
                    alert("Kuantiti buku mesti lebih daripada 0.");
                    return;
                }
            }
        }

        if (category === "runcit") {
            if (!quantities["kuantity"] || parseInt(quantities["kuantity"]) <= 0) {
                alert("Kuantiti barang runcit mesti lebih daripada 0.");
                return;
            }
        }




        // 1. Harga ikut kategori
        let hargaToSave = {
            kos: parseFloat(hargaKos) || 0,
            pengerusi: parseFloat(hargaJualPengerusi) || 0,
            pengurus: parseFloat(hargaJualPengurus) || 0
        };
        if (category === "baju") {
            hargaToSave = {};
            sizes.forEach(size => {
                hargaToSave[size] = {
                    kos: parseFloat(hargaSaiz[size]?.kos) || 0,
                    pengerusi: parseFloat(hargaSaiz[size]?.pengerusi) || 0,
                    pengurus: parseFloat(hargaSaiz[size]?.pengurus) || 0,
                }
            });
        } else if (category === "buku" && splitByYear) {
            hargaToSave = {};
            years.forEach(year => {
                hargaToSave[year] = {
                    kos: parseFloat(hargaTahun[year]?.kos) || 0,
                    pengerusi: parseFloat(hargaTahun[year]?.pengerusi) || 0,
                    pengurus: parseFloat(hargaTahun[year]?.pengurus) || 0,
                }
            });
        } else if (category === "buku") {
            hargaToSave = {
                kos: parseFloat(hargaKos) || 0,
                pengerusi: parseFloat(hargaJualPengerusi) || 0,
                pengurus: parseFloat(hargaJualPengurus) || 0,
            };
        }



        // 2. Basic stockData
        const nextPriority = await getNextPriority();
        const stockData = {
            category,
            name: itemName.trim(),
            desc: desc.trim(),
            imageUrl: uploadedImageUrl,
            harga: hargaToSave,
            addedDate: new Date(),
            isAvailable: true,
            createBy: currentUser?.name || "anonymous",
            createById: currentUser?.id || "",
            priority: nextPriority,
        };

        // 3. Tambah field ikut kategori
        if (category === "baju") {
            stockData.gender = gender;
            stockData.sizeQuantities = Object.fromEntries(
                Object.entries(quantities).map(([size, qty]) => [size, parseInt(qty) || 0])
            );
        }
        else if (category === "buku" && splitByYear) {
            stockData.yearQuantities = Object.fromEntries(
                Object.entries(quantities).map(([year, qty]) => [year, parseInt(qty) || 0])
            );
        } else if (category === "buku") {
            stockData.quantity = parseInt(quantities["qty"] || 0);
        }
        else if (category === "runcit") {
            stockData.quantity = parseInt(quantities["kuantity"] || 0);
        }




        try {
            // 🔥 Simpan stok ke dalam subkoleksi `selangor/{docId}/stocks`
            await addDoc(collection(db, "inventori", "selangor", "stocks"), stockData);
            // → Tambah log ke stockLogs
            await addDoc(collection(db, "inventori", "selangor", "stockLogs"), {
                itemName: stockData.name,
                category: stockData.category,
                quantity:
                    category === "baju"
                        ? Object.values(stockData.sizeQuantities || {}).reduce((a, b) => a + (b || 0), 0)
                        : category === "buku" && splitByYear
                            ? Object.values(stockData.yearQuantities || {}).reduce((a, b) => a + (b || 0), 0)
                            : stockData.quantity || 0,
                action: "stok masuk",
                district: currentUser?.district || "-",
                timestamp: new Date(),
            });

            // Tunjukkan alert
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 2000);
            setCategory("");
            setItemName("");
            setDesc("");
            setGender("");
            setQuantities({});
            setImage(null);
            setHargaKos("");
            setHargaJualPengerusi("");
            setHargaJualPengurus("");
            setHargaSaiz({});
            setHargaTahun({});
            document.querySelector('input[type="file"]').value = "";

        } catch (error) {
            console.error("Error adding stock:", error);
        }
    };

    const getNextPriority = async () => {
        const snapshot = await getDocs(collection(db, "inventori", "selangor", "stocks"));
        let maxPriority = -1;
        snapshot.forEach(doc => {
            const p = doc.data().priority;
            if (typeof p === "number" && p > maxPriority) maxPriority = p;
        });
        return maxPriority + 1;
    };

    return (
        <div className="stock-form-container">
            <AlertMessage message="Berjaya ditambah!" isVisible={showAlert} />

            <h2>Tambah Stok Baru</h2>
            <form onSubmit={addStock} className="stock-form">
                <label>Kategori:</label>
                <select value={category} onChange={(e) => setCategory(e.target.value)} required>
                    <option value="">Pilih Kategori</option>
                    {categories.map((cat) => (
                        <option key={cat} value={cat}>{cat}</option>
                    ))}
                </select>

                <label>Nama Barang:</label>
                <input type="text" value={itemName} onChange={(e) => setItemName(e.target.value)} required />

                {category === "baju" && (
                    <>
                        <label>Jantina:</label>
                        <select value={gender} onChange={(e) => setGender(e.target.value)} required>
                            <option value="">Pilih</option>
                            <option value="lelaki">Lelaki</option>
                            <option value="perempuan">Perempuan</option>
                            <option value="unisex">Unisex</option>
                        </select>

                        <div className="baju-saiz-table">
                            <div className="baju-saiz-header">
                                <span style={{ width: 80 }}>Saiz</span>
                                <span style={{ width: 120 }}>Kuantiti</span>
                                <span style={{ width: 80 }}>Kos (RM)</span>
                                <span style={{ width: 90 }}>Pengerusi (RM)</span>
                                <span style={{ width: 90 }}>Pengurus (RM)</span>
                            </div>
                            {sizes.map((size) => (
                                <div className="baju-saiz-row" key={size}>
                                    <span style={{ width: 80 }}>{size}</span>
                                    <input
                                        style={{ width: 100, marginRight: 10 }}
                                        type="number"
                                        placeholder="Kuantiti"
                                        value={quantities[size] || ""}
                                        onChange={(e) =>
                                            setQuantities({ ...quantities, [size]: e.target.value })
                                        }
                                    />
                                    <input
                                        style={{ width: 80, marginRight: 10 }}
                                        type="number"
                                        placeholder="Kos"
                                        value={hargaSaiz[size]?.kos || ""}
                                        onChange={(e) =>
                                            setHargaSaiz({
                                                ...hargaSaiz,
                                                [size]: {
                                                    ...hargaSaiz[size],
                                                    kos: e.target.value,
                                                },
                                            })
                                        }
                                    />
                                    <input
                                        style={{ width: 90, marginRight: 10 }}
                                        type="number"
                                        placeholder="Pengerusi"
                                        value={hargaSaiz[size]?.pengerusi || ""}
                                        onChange={(e) =>
                                            setHargaSaiz({
                                                ...hargaSaiz,
                                                [size]: {
                                                    ...hargaSaiz[size],
                                                    pengerusi: e.target.value,
                                                },
                                            })
                                        }
                                    />
                                    <input
                                        style={{ width: 90 }}
                                        type="number"
                                        placeholder="Pengurus"
                                        value={hargaSaiz[size]?.pengurus || ""}
                                        onChange={(e) =>
                                            setHargaSaiz({
                                                ...hargaSaiz,
                                                [size]: {
                                                    ...hargaSaiz[size],
                                                    pengurus: e.target.value,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                    </>
                )}


                {category === "buku" && (
                    <>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                            <input
                                type="checkbox"
                                checked={splitByYear}
                                onChange={e => setSplitByYear(e.target.checked)}
                                style={{ accentColor: "#228b22", width: 18, height: 18 }}
                            />
                            <span>Buku ini ada pecahan tahun (4/5/6 tahun)</span>
                        </label>

                        {splitByYear ? (
                            <div className="buku-tahun-table">
                                <div className="buku-tahun-header">
                                    <span style={{ width: 80 }}>Tahun</span>
                                    <span style={{ width: 120 }}>Kuantiti</span>
                                    <span style={{ width: 80 }}>Kos (RM)</span>
                                    <span style={{ width: 90 }}>Pengerusi (RM)</span>
                                    <span style={{ width: 90 }}>Pengurus (RM)</span>
                                </div>
                                {years.map((year) => (
                                    <div className="buku-tahun-row" key={year}>
                                        <span style={{ width: 80 }}>{year}</span>
                                        <input
                                            style={{ width: 100, marginRight: 10 }}
                                            type="number"
                                            placeholder="Kuantiti"
                                            value={quantities[year] || ""}
                                            onChange={(e) =>
                                                setQuantities({ ...quantities, [year]: e.target.value })
                                            }
                                        />
                                        <input
                                            style={{ width: 80, marginRight: 10 }}
                                            type="number"
                                            placeholder="Kos"
                                            value={hargaTahun[year]?.kos || ""}
                                            onChange={(e) =>
                                                setHargaTahun({
                                                    ...hargaTahun,
                                                    [year]: {
                                                        ...hargaTahun[year],
                                                        kos: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                        <input
                                            style={{ width: 90, marginRight: 10 }}
                                            type="number"
                                            placeholder="Pengerusi"
                                            value={hargaTahun[year]?.pengerusi || ""}
                                            onChange={(e) =>
                                                setHargaTahun({
                                                    ...hargaTahun,
                                                    [year]: {
                                                        ...hargaTahun[year],
                                                        pengerusi: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                        <input
                                            style={{ width: 90 }}
                                            type="number"
                                            placeholder="Pengurus"
                                            value={hargaTahun[year]?.pengurus || ""}
                                            onChange={(e) =>
                                                setHargaTahun({
                                                    ...hargaTahun,
                                                    [year]: {
                                                        ...hargaTahun[year],
                                                        pengurus: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <>
                                <label>Kuantiti:</label>
                                <input
                                    type="number"
                                    value={quantities["qty"] || ""}
                                    onChange={e => setQuantities({ ...quantities, qty: e.target.value })}
                                    required
                                />
                                <label>Harga Kos (RM):</label>
                                <input
                                    type="number"
                                    value={hargaKos}
                                    onChange={e => setHargaKos(e.target.value)}
                                    required
                                />
                                <label>Harga Pengerusi (RM):</label>
                                <input
                                    type="number"
                                    value={hargaJualPengerusi}
                                    onChange={e => setHargaJualPengerusi(e.target.value)}
                                    required
                                />
                                <label>Harga Pengurus (RM):</label>
                                <input
                                    type="number"
                                    value={hargaJualPengurus}
                                    onChange={e => setHargaJualPengurus(e.target.value)}
                                    required
                                />
                            </>
                        )}
                    </>
                )}



                {category === "runcit" && (
                    <>
                        <label>Kuantiti:</label>
                        <input type="number" value={quantities["kuantity"] || ""} onChange={(e) => setQuantities({ kuantity: e.target.value })} required />
                    </>
                )}

                <label>Keterangan:</label>
                <textarea
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                    rows={4}
                    required
                />

                {category === "runcit" && (
                    <>
                        <label>Harga Kos (RM):</label>
                        <input type="number" value={hargaKos} onChange={(e) => setHargaKos(e.target.value)} required />

                        <label>Harga Jual kepada Pengerusi (RM):</label>
                        <input type="number" value={hargaJualPengerusi} onChange={(e) => setHargaJualPengerusi(e.target.value)} required />

                        <label>Harga Jual kepada Pengurus (RM):</label>
                        <input type="number" value={hargaJualPengurus} onChange={(e) => setHargaJualPengurus(e.target.value)} required />
                    </>
                )}


                <label>Muat Naik Gambar:</label>
                <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
                {image && <p>Gambar: {image.name}</p>}

                <button type="submit" className="submit-button">Tambah</button>
            </form>
        </div>
    );
};

export default StockForm;
